var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal",
      attrs: {
        id: "my-card-share-setup-modal",
        title: "공개 범위 설정",
        okTitle: "저장",
        okBusy: _vm.isLoading,
        okDisabled: _vm.isLoading
      },
      on: {
        ok: function($event) {
          return _vm.onModalOkClick(_vm.selectedMyCardShareLevel)
        },
        cancel: _vm.onModalCancelClick
      }
    },
    [
      _c(
        "div",
        { staticClass: "display-block" },
        [
          _c(
            "Radio",
            {
              attrs: {
                id: "private",
                "model-value": _vm.selectedMyCardShareLevel,
                "check-value": 2
              },
              on: {
                change: function($event) {
                  return _vm.handleShareLevelChange(2)
                }
              }
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("비공개")
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "display-block" },
        [
          _c(
            "Radio",
            {
              attrs: {
                id: "public",
                "model-value": _vm.selectedMyCardShareLevel,
                "check-value": 3
              },
              on: {
                change: function($event) {
                  return _vm.handleShareLevelChange(3)
                }
              }
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("소속 기관에만 공개")
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "display-block" },
        [
          _c(
            "Radio",
            {
              attrs: {
                id: "academy",
                "model-value": _vm.selectedMyCardShareLevel,
                "check-value": 1
              },
              on: {
                change: function($event) {
                  return _vm.handleShareLevelChange(1)
                }
              }
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("전체 공개")
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isPublisher
        ? _c(
            "div",
            { staticClass: "display-block" },
            [
              _c(
                "Radio",
                {
                  attrs: {
                    id: "hidden",
                    "model-value": _vm.selectedMyCardShareLevel,
                    "check-value": 99
                  },
                  on: {
                    change: function($event) {
                      return _vm.handleShareLevelChange(99)
                    }
                  }
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("숨기기")
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d3d8910", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d3d8910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/my-cards/components/MyCardShareSetupModal.vue
// module id = Xc7h
// module chunks = 1